import React from 'react';

import '@common/react/scss/components/nativeDatepicker.scss';

interface Props {
	value: number;
	onChange: (value: number | null) => void;
	maxToday?: boolean;
	minToday?: boolean;
	name?: string;
	className?: string;
	placeholder?: string;
}

const getDate = () => {
	const date = new Date();
	const month = date.getMonth() + 1;
	const day = date.getDate();
	return `${date.getFullYear()}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
};

const NativeDatepicker: React.FC<Props> = (props) => {
	const {
		value,
		onChange,
		maxToday,
		minToday,
		name,
		className = '',
		placeholder = 'Date',
	} = props;
	const input = React.useRef<HTMLInputElement>(null);
	const [currentValue, setCurrentValue] = React.useState<string>();
	const max = React.useMemo(() => {
		return maxToday ? getDate() : undefined;
	}, [maxToday]);
	const min = React.useMemo(() => {
		return minToday ? getDate() : undefined;
	}, [minToday]);

	return <div className="is-relative">
		<input
			ref={input}
			type="date"
			name={name}
			max={max}
			min={min}
			onInput={(e) => {
				const target: any = e.nativeEvent.target;
				window.setTimeout(() => {
					if (target) target.defaultValue = '';
				}, 0);
			}}
			placeholder={placeholder}
			className={`form-control ${className} ${currentValue ? 'has-value' : ''}`}
			onChange={(e) => {
				setCurrentValue(e.currentTarget.value);
				const solvedValue = +new Date(e.currentTarget.value);
				onChange && onChange(e.currentTarget.value ? solvedValue || null : null);
			}}
			value={currentValue}
		/>
		{value && <button
			type="button"
			title="Clear"
			className="native-datepicker-button"
			onClick={() => {
				setCurrentValue('');
				onChange && onChange(null);
				input.current?.focus();
			}}
		>
			<i className="fa fa-times-circle" />
		</button>}
	</div>;
};

export default NativeDatepicker;
